export default {"src":"/_next/static/media/iconmonstr-error-filled.c777f64d.svg","height":24,"width":24};